import { render } from "./Spacer.vue?vue&type=template&id=5c380e42&scoped=true"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

import "./Spacer.vue?vue&type=style&index=0&id=5c380e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c380e42"]])

export default __exports__